<template>
  <el-row :gutter="15">
    <el-col :span="24">
      <Filters
        class="mb-3"
        :resource="$sdk.locationcarrierzone"
        context="pivot"
        :filters.sync="filters"
        @apply="reload"
        @ready="loadLocationCarrierZoneList"
      />
      <el-card
        shadow="never"
      >
        <LocationCarrierzonesTable
          ref="contactTbl"
          v-loading="isLoading"
          :lczs="lczs"
          @refresh="reload"
          @edit="edit"
        />
        <br>
        <div style="text-align: center;">
          <el-pagination
            :current-page.sync="lczs.page"
            :page-size.sync="lczs.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="lczs.total"
            @size-change="reload()"
            @current-change="reload()"
          />
        </div>
        <LocationCarrierzoneForm
          ref="lcz"
          :lcz="lcz"
          :operator="create"
          @refresh="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import LocationCarrierzonesTable from '@/components/Application/Manage/Carriers/LocationCarrierZonesTable'
import LocationCarrierzoneForm from '@/components/Application/Manage/Carriers/LocationCarrierZoneForm'
import Filters from '@/components/Filters/Complex'
import { CREATE } from '@/plugins/user'
export default {
  components: {
    LocationCarrierzonesTable,
    LocationCarrierzoneForm,
    Filters
  },
  data () {
    return {
      pageTitle: 'Detail',
      breadcrumb: {
        name: 'Detail',
        route: { name: 'configuration-locations-location-detail', params: { locationId: this.$route.params.locationId } }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'carrier_locationzone'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.showForm()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.loadLocationCarrierZoneList()
          }
        }
      ],
      form: {
        country: null, suburb: null, state: null, pobox: null, postcode: null
      },
      page: 1,
      perPage: 10,
      total: 0,
      sort: 'desc',
      isLoading: false,
      isSaving: false,
      lczs: [],
      create: true,
      editMode: false,
      location: {},
      lcz: {
        carrier: {},
        location: { postcode: null, suburb: null, state: null, custom: null },
        zone: { desc: null },
        zone_parent: { desc: null }
      },
      filters: []
    }
  },
  mounted () {
    this.getLocationById()
  },
  methods: {
    async reload () {
      try {
        this.isLoading = true
        await this.lczs.reload(builder => {
          builder.filters = this.filters
          builder.filters = { 'pivot_location_carrier_zone_location': this.$route.params.locationId }
        })
      } catch {
        this.$message.error('An error occurred while loading data')
      } finally {
        this.isLoading = false
      }
    },
    loadLocationCarrierZoneList () {
      this.isLoading = true
      this.$sdk.locationcarrierzone.list((builder) => {
        builder.context = { resource: 'pivot' }
        builder.include = ['carrier', 'location', 'zone', 'zone_parent']
        builder.filters = this.filters
        builder.filters = { 'pivot_location_carrier_zone_location': this.$route.params.locationId }
        builder.order = 'created_at:desc'
      }).then(res => {
        this.lczs = res
        this.isLoading = false
        this.reset()
      })
    },
    showForm (row) {
      this.reset()
      if (row) {
        this.create = false
        this.lcz = row
        this.$refs.lcz.showDialog()

        this.$refs.lcz.carrierDisable = false
        this.$refs.lcz.locationDisable = true
        this.lcz.location.custom = `${row.location.suburb}, ${row.location.state}, ${row.location.postcode}`
      } else {
        this.create = true
        this.$refs.lcz.locationDisable = true
        this.$refs.lcz.carrierDisable = false
        if (this.lcz.location.suburb == null) {
          this.lcz.location = this.location
        }
        this.$refs.lcz.showDialog()
      }
    },
    edit (row) {
      this.showForm(row)
    },
    reset () {
      this.lcz = new this.$sdk.locationcarrierzone()
      this.lcz.carrier = new this.$sdk.carrier()
      this.lcz.location = new this.$sdk.dictionary_location()
      this.lcz.zone = new this.$sdk.dictionary_zone()
      this.lcz.zone_parent = new this.$sdk.dictionary_zone()
    },
    getLocationById () {
      this.$sdk
        .location.read(this.$route.params.locationId)
        .then((response) => {
          this.location = response
        })
    }
  }
}
</script>
